// frontend/src/pages/BrandPage.jsx
import React, { useState } from 'react';
import logoBlack from '../assets/log_pichAI_black.png';
import logoWhite from '../assets/log_pichAI_white.png';
import logoBlackBl from '../assets/log_pichAI_black_bl.png';
import logoWhtBl from '../assets/log_pichAI_wht_bl.png';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .bp-root {
    min-height: 100vh;
    background: #FAFAFA;
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
    color: #0F172A;
    -webkit-font-smoothing: antialiased;
  }

  /* ── HERO ── */
  .bp-hero {
    position: relative;
    background: #FFFFFF;
    border-bottom: 1px solid #E2E8F0;
    padding: 88px 24px 64px;
    overflow: hidden;
  }
  .bp-hero::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -10%;
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, rgba(37,99,235,0.06) 0%, transparent 70%);
    pointer-events: none;
  }
  .bp-hero-inner {
    max-width: 1080px;
    margin: 0 auto;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 40px;
    flex-wrap: wrap;
    position: relative;
  }
  .bp-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #EEF2FF;
    color: #4338CA;
    border: 1px solid #C7D2FE;
    border-radius: 999px;
    font-family: 'Inter', system-ui, sans-serif;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    padding: 5px 14px;
    margin-bottom: 24px;
    text-transform: uppercase;
  }
  .bp-chip-dot {
    width: 6px; height: 6px; border-radius: 50%;
    background: #6366F1;
    animation: bp-pulse 2s infinite;
  }
  @keyframes bp-pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
  }
  .bp-h1 {
    font-size: 44px;
    font-weight: 700;
    letter-spacing: -0.025em;
    line-height: 1.1;
    color: #0F172A;
    margin-bottom: 16px;
  }
  .bp-h1 span { color: #2563EB; }
  .bp-desc {
    font-size: 15px;
    color: #475569;
    line-height: 1.7;
    max-width: 480px;
    font-weight: 400;
  }
  .bp-hero-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    padding-bottom: 6px;
  }
  .bp-stat {
    font-size: 13px;
    color: #64748B;
    text-align: right;
    font-weight: 500;
  }
  .bp-stat strong {
    font-weight: 700;
    display: block;
    font-size: 18px;
    color: #1E293B;
    line-height: 1.2;
  }

  /* ── BODY ── */
  .bp-body {
    max-width: 1080px;
    margin: 0 auto;
    padding: 64px 24px 96px;
  }

  /* ── SECTION LABEL ── */
  .bp-section-label {
    display: flex;
    align-items: center;
    gap: 14px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #94A3B8;
    margin-bottom: 28px;
    font-family: 'Inter', system-ui, sans-serif;
  }
  .bp-section-label::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #E2E8F0;
    margin-left: 4px;
  }

  /* ── LOGO GROUP ── */
  .bp-group {
    margin-bottom: 60px;
  }
  .bp-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }
  @media (max-width: 640px) {
    .bp-grid { grid-template-columns: 1fr; }
    .bp-h1 { font-size: 30px; }
    .bp-hero-meta { display: none; }
    .bp-hero { padding: 64px 20px 40px; }
    .bp-body { padding: 40px 20px 64px; }
  }

  /* ── CARD ── */
  .bp-card {
    background: #FFFFFF;
    border: 1px solid #E2E8F0;
    border-radius: 20px;
    overflow: hidden;
    transition: box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s;
    position: relative;
  }
  .bp-card:hover {
    box-shadow: 0 12px 32px rgba(0,0,0,0.06), 0 4px 8px rgba(0,0,0,0.03);
    transform: translateY(-3px);
    border-color: #CBD5E1;
  }

  /* badge */
  .bp-badge {
    position: absolute;
    top: 16px;
    right: 16px;
    font-family: 'Inter', system-ui, sans-serif;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.03em;
    padding: 4px 10px;
    border-radius: 999px;
    border: 1px solid;
    text-transform: uppercase;
    z-index: 2;
  }
  .bp-badge-light { background: #F8FAFC; border-color: #E2E8F0; color: #475569; }
  .bp-badge-dark  { background: rgba(15,23,42,0.25); border-color: rgba(255,255,255,0.12); color: rgba(255,255,255,0.6); backdrop-filter: blur(4px); }
  .bp-badge-blue  { background: #EEF2FF; border-color: #C7D2FE; color: #4338CA; }

  /* preview */
  .bp-preview {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    padding: 40px;
  }
  .bp-preview img {
    max-height: 64px;
    max-width: 80%;
    object-fit: contain;
    transition: transform 0.3s ease;
  }
  .bp-card:hover .bp-preview img { transform: scale(1.06); }

  /* card footer */
  .bp-card-foot {
    padding: 20px 24px 24px;
    border-top: 1px solid #F1F5F9;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }
  .bp-card-info {}
  .bp-card-name {
    font-size: 14px;
    font-weight: 600;
    color: #0F172A;
    margin-bottom: 2px;
  }
  .bp-card-sub {
    font-size: 11px;
    color: #64748B;
    font-weight: 400;
  }

  /* download button */
  .bp-dl-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 18px;
    border-radius: 999px;
    border: 1px solid #E2E8F0;
    background: #FFFFFF;
    font-family: 'Inter', system-ui, sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: #1E293B;
    text-decoration: none;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s ease;
    flex-shrink: 0;
    box-shadow: 0 1px 2px rgba(0,0,0,0.02);
  }
  .bp-dl-btn:hover {
    background: #0F172A;
    border-color: #0F172A;
    color: #FFFFFF;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    transform: translateY(-1px);
  }
  .bp-dl-btn:active { transform: scale(0.98); }
  .bp-dl-btn.done {
    background: #ECFDF5;
    border-color: #A7F3D0;
    color: #065F46;
    box-shadow: none;
  }
  .bp-dl-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px; height: 20px;
    border-radius: 50%;
    background: currentColor;
    flex-shrink: 0;
  }
  .bp-dl-icon svg { color: #fff; fill: #fff; width: 12px; height: 12px; }
  .bp-dl-btn.done .bp-dl-icon { background: #059669; }

  /* ── USAGE ── */
  .bp-usage {
    background: #FFFFFF;
    border: 1px solid #E2E8F0;
    border-radius: 20px;
    padding: 36px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    margin-top: 12px;
  }
  @media (max-width: 640px) {
    .bp-usage { grid-template-columns: 1fr; padding: 28px 24px; }
  }

  .bp-usage-col-title {
    font-size: 14px;
    font-weight: 700;
    color: #0F172A;
    margin-bottom: 18px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .bp-usage-col-title::before {
    content: '';
    width: 4px; height: 16px;
    background: #2563EB;
    border-radius: 2px;
    display: inline-block;
  }
  .bp-rules {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .bp-rules li {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    font-size: 13px;
    color: #334155;
    line-height: 1.6;
  }
  .bp-rules li::before {
    content: '';
    width: 5px; height: 5px;
    border-radius: 50%;
    background: #CBD5E1;
    flex-shrink: 0;
    margin-top: 7px;
  }

  .bp-url-block {
    background: #F8FAFC;
    border: 1px solid #E2E8F0;
    border-radius: 12px;
    padding: 20px 22px;
    margin-top: 24px;
  }
  .bp-url-lbl {
    font-size: 10px;
    font-weight: 600;
    color: #64748B;
    margin-bottom: 8px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }
  .bp-url-val {
    font-size: 13px;
    font-weight: 500;
    color: #2563EB;
    word-break: break-all;
    font-family: 'Inter', system-ui, sans-serif;
  }
  .bp-copy-btn {
    margin-top: 12px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-family: 'Inter', system-ui, sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    transition: color 0.2s, opacity 0.2s;
  }
  .bp-copy-btn:hover { color: #0F172A; }
`;

// ─── DATA ───────────────────────────────────────────────────────
const LOGO_GROUPS = [
  {
    section: 'Logos mono — sans accent couleur',
    logos: [
      {
        id: 'black',
        label: 'Logo noir',
        sub: 'PNG · Fond clair',
        description: 'Fond clair / documents officiels',
        src: logoBlack,
        filename: 'log_pichAI_black.png',
        downloadPath: '/brand/log_pichAI_black.png',
        bg: '#FFFFFF',
        badge: 'Fond clair',
        badgeClass: 'bp-badge-light',
      },
      {
        id: 'white',
        label: 'Logo blanc',
        sub: 'PNG · Fond sombre',
        description: 'Fond sombre / interfaces dark mode',
        src: logoWhite,
        filename: 'log_pichAI_white.png',
        downloadPath: '/brand/log_pichAI_white.png',
        bg: '#0B0E14',
        badge: 'Fond sombre',
        badgeClass: 'bp-badge-dark',
      },
    ],
  },
  {
    section: 'Logos bicolores — avec accent bleu sur "AI"',
    logos: [
      {
        id: 'black_bl',
        label: 'Logo noir + bleu',
        sub: 'PNG · Fond clair',
        description: '"Pich" en noir, "AI" en bleu',
        src: logoBlackBl,
        filename: 'log_pichAI_black_bl.png',
        downloadPath: '/brand/log_pichAI_black_bl.png',
        bg: '#FFFFFF',
        badge: 'Bicolore · Fond clair',
        badgeClass: 'bp-badge-blue',
      },
      {
        id: 'wht_bl',
        label: 'Logo blanc + bleu',
        sub: 'PNG · Fond clair',
        description: '"Pich" en blanc, "AI" en bleu',
        src: logoWhtBl,
        filename: 'log_pichAI_wht_bl.png',
        downloadPath: '/brand/log_pichAI_wht_bl.png',
        bg: '#F1F5F9',
        badge: 'Bicolore · Fond clair',
        badgeClass: 'bp-badge-blue',
      },
    ],
  },
];

// ─── DOWNLOAD BUTTON ────────────────────────────────────────────
function DlBtn({ logo, done, onDownload }) {
  return (
    <a
      href={logo.downloadPath}
      download={logo.filename}
      className={`bp-dl-btn${done ? ' done' : ''}`}
      onClick={onDownload}
    >
      <span className="bp-dl-icon">
        {done
          ? <svg viewBox="0 0 12 12"><path d="M2 6l3 3 5-5" stroke="#fff" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>
          : <svg viewBox="0 0 12 12"><path d="M6 2v6M3 6l3 3 3-3" stroke="#fff" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>
        }
      </span>
      {done ? 'Téléchargé !' : 'Télécharger'}
    </a>
  );
}

// ─── MAIN ───────────────────────────────────────────────────────
export default function BrandPage() {
  const [downloaded, setDownloaded] = useState({});
  const [copied, setCopied] = useState(false);

  const handleDownload = (id) => {
    setDownloaded((p) => ({ ...p, [id]: true }));
    setTimeout(() => setDownloaded((p) => ({ ...p, [id]: false })), 2500);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText('https://pichai.tech/brand');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const totalLogos = LOGO_GROUPS.reduce((acc, g) => acc + g.logos.length, 0);

  return (
    <>
      <style>{STYLES}</style>
      <div className="bp-root">

        {/* HERO */}
        <div className="bp-hero">
          <div className="bp-hero-inner">
            <div>
              <div className="bp-chip">
                <span className="bp-chip-dot" />
                Brand Kit officiel
              </div>
              <h1 className="bp-h1">
                Ressources <span>visuelles</span><br />PICH AI
              </h1>
              <p className="bp-desc">
                Logos officiels du projet disponibles en téléchargement libre.
                Choisissez la variante adaptée à votre contexte d'utilisation.
              </p>
            </div>
            <div className="bp-hero-meta">
              <div className="bp-stat">
                <strong>{totalLogos}</strong>
                variantes disponibles
              </div>
              <div className="bp-stat">
                <strong>PNG</strong>
                format haute qualité
              </div>
            </div>
          </div>
        </div>

        {/* BODY */}
        <div className="bp-body">

          {/* LOGO GROUPS */}
          {LOGO_GROUPS.map((group) => (
            <div key={group.section} className="bp-group">
              <div className="bp-section-label">{group.section}</div>
              <div className="bp-grid">
                {group.logos.map((logo) => (
                  <div key={logo.id} className="bp-card">
                    <span className={`bp-badge ${logo.badgeClass}`}>{logo.badge}</span>

                    {/* Aperçu */}
                    <div className="bp-preview" style={{ background: logo.bg }}>
                      <img src={logo.src} alt={logo.label} />
                    </div>

                    {/* Footer de la carte */}
                    <div className="bp-card-foot">
                      <div className="bp-card-info">
                        <div className="bp-card-name">{logo.label}</div>
                        <div className="bp-card-sub">{logo.sub} &mdash; {logo.description}</div>
                      </div>
                      <DlBtn
                        logo={logo}
                        done={!!downloaded[logo.id]}
                        onDownload={() => handleDownload(logo.id)}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* USAGE + URL */}
          <div className="bp-section-label" style={{ marginBottom: 28 }}>Directives d'utilisation</div>
          <div className="bp-usage">
            <div>
              <div className="bp-usage-col-title">Utilisation correcte</div>
              <ul className="bp-rules">
                <li>Logo noir sur fond clair (blanc, gris clair, documents).</li>
                <li>Logo blanc sur fond sombre ou interface en dark mode.</li>
                <li>Logos bicolores sur fond clair uniquement pour mettre en valeur "AI" en bleu.</li>
                <li>Conserver les proportions d'origine — ne pas déformer.</li>
                <li>Espace minimum autour du logo équivalent à sa hauteur.</li>
              </ul>
            </div>
            <div>
              <div className="bp-usage-col-title">À éviter</div>
              <ul className="bp-rules">
                <li>Ne pas modifier les couleurs du logo.</li>
                <li>Ne pas ajouter d'ombre, de contour ou d'effet.</li>
                <li>Ne pas placer le logo blanc sur fond clair.</li>
                <li>Ne pas utiliser une version floue ou redimensionnée en basse qualité.</li>
                <li>Ne pas rogner ou masquer une partie du logo.</li>
              </ul>
              <div className="bp-url-block">
                <div className="bp-url-lbl">URL publique de cette page</div>
                <div className="bp-url-val">https://pichai.tech/brand</div>
                <button className="bp-copy-btn" onClick={handleCopy}>
                  {copied ? '✓ Copié !' : '⎘ Copier le lien'}
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}